class TokenValue {
  constructor(data = {}) {
    this.id = data.id || null;
    this.currency = data.currency || "";
    this.worth = data.worth || 0;
  }
}

export default TokenValue;
